(function () {
    class NullAuthenticationStrategy {
        constructor(config) {}
        login(options) {
            return Promise.resolve();
        }
        logout() {
            return Promise.resolve();
        }
        async isAuthenticated() {
            return true;
        }
        user() {
            return { username: 'john doe', roles: []};
        }
    }
    AuthenticationProvider.add("NullAuthenticationStrategy", (config) => {
        return new NullAuthenticationStrategy(config);
    });
})();
